import RequireUserMiddleware from 'middlewares/RequireUserMiddleware'
import RequireSignupFinishedMiddleware from 'middlewares/RequireSignupFinishedMiddleware'
import RequirePhysicianOrAncillaryOrDemoMiddleware from 'middlewares/RequirePhysicianOrAncillaryOrDemoMiddleware'
import { ucfirst } from '~/helpers'
import { steps as newReferralSteps } from 'mixins/ReferralsNewPageMixin'

export default [
    ...['received', 'made'].map((type) => ({
        path: `/referrals/pool/${type}/:id`,
        name: `referrals.${type}.pool.show`,
        view: 'referrals/pool/ReferralPoolShow',
        default: { params: { type } },
        middlewares: [RequireSignupFinishedMiddleware, RequirePhysicianOrAncillaryOrDemoMiddleware, RequireUserMiddleware],
    })),
    {
        path: '/referrals-pool/:poolId/location/:locationId',
        name: 'referrals.pool.propose.time',
        view: 'referrals/pool/ReferralPoolProposeTime',
        middlewares: [RequireSignupFinishedMiddleware, RequirePhysicianOrAncillaryOrDemoMiddleware, RequireUserMiddleware],
    },
    {
        path: '/referrals-pool/new',
        name: 'pool.new',
        redirect: { name: `pool.new.${newReferralSteps[0]}` },
    },
    ...newReferralSteps.map((step) => ({
        path: `/referrals-pool/new/${step}`,
        name: `pool.new.${step}`,
        view: `referrals/new/${ucfirst(step)}`,
        default: { query: { limit: 6 }, params: { step } },
        middlewares: [RequireSignupFinishedMiddleware, RequirePhysicianOrAncillaryOrDemoMiddleware, RequireUserMiddleware],
    })),
]
